var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 295,
    viewBox: "0 0 295 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2979 104.278C37.2437 51.6206 86.1505 13.2979 144.014 13.2979C214.818 13.2979 272.216 70.6967 272.216 141.5C272.216 212.303 214.818 269.702 144.014 269.702C87.0803 269.702 38.8088 232.588 22.0882 181.233",
    stroke: "url(#paint0_linear_1407_3400)",
    strokeWidth: 18.5603,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.494 119.309C190.643 116.628 186.862 115.28 182.166 115.28C177.471 115.28 173.442 116.628 170.59 119.309C167.739 121.99 166.313 125.601 166.313 130.141V174.833C166.313 187.137 160.502 199.271 147.113 200.913C131.137 202.866 122.722 189.012 122.722 174.833V130.141C122.722 125.601 121.296 122.005 118.445 119.309C115.594 116.628 111.735 115.28 106.869 115.28C102.003 115.28 98.3925 116.628 95.5412 119.309C92.6898 121.99 91.2642 125.601 91.2642 130.141V176.166C91.2642 210.01 114.307 230.016 144.432 230.109C144.463 230.109 144.494 230.109 144.525 230.109C144.556 230.109 144.587 230.109 144.618 230.109C174.744 230.031 197.787 210.01 197.787 176.166V130.141C197.787 125.601 196.361 122.005 193.51 119.309H193.494Z",
    fill: "#4FC0CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.776 98.5593C114.864 98.5593 121.42 92.0029 121.42 83.9151C121.42 75.8274 114.864 69.271 106.776 69.271C98.6885 69.271 92.1321 75.8274 92.1321 83.9151C92.1321 92.0029 98.6885 98.5593 106.776 98.5593Z",
    fill: "#4FC0CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.942 98.1563C189.03 98.1563 195.586 91.5999 195.586 83.5122C195.586 75.4244 189.03 68.868 180.942 68.868C172.854 68.868 166.298 75.4244 166.298 83.5122C166.298 91.5999 172.854 98.1563 180.942 98.1563Z",
    fill: "#4FC0CF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1407_3400",
    x1: 146.757,
    y1: 3.99998,
    x2: 146.757,
    y2: 279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ED957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#6ACE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#51C1C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3B9EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1E6E95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDarkIcon);
export default __webpack_public_path__ + "static/media/logoDarkIcon.650a6f82f55e07f80475944b20b3a3d7.svg";
export { ForwardRef as ReactComponent };